module.exports = __webpack_public_path__ + "media/images/blobs/blob-brown-693165a407f21fa6824e373a51ca483a.svg";